/* unplugin-vue-components disabled */import script from "./IncidentTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./IncidentTable.vue?vue&type=script&lang=ts&setup=true"

import "./IncidentTable.vue?vue&type=style&index=0&id=3673ce08&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3673ce08"]])

export default __exports__